import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {
    // transform function of the filter pipe to be able to filter a
    public transform<T extends { [key: string]: string }>(items: T[], filter: { [key: string]: string }): T[] {
        if (items) {
            return items.filter((item) => {
                const notMatchingField = Object.keys(filter).find((key) => {
                    return (
                        filter[key] !== '' &&
                        item[key].toLocaleLowerCase().indexOf(filter[key].toLocaleLowerCase()) === -1
                    );
                });

                return !notMatchingField; // true if matches all fields
            });
        }
        return [];
    }
}
